import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: Date): string {
    const now = new Date();
    const incomingData = new Date(value);
    const seconds = Math.floor((now.getTime() - incomingData.getTime()) / 1000);
    if (seconds <= 0) {
      return 1 + ' seconds ago';
    }
    if (seconds < 60) {
      return seconds + ' seconds ago';
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
      return minutes + ' minutes ago';
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return hours + ' hours ago';
    }

    const days = Math.floor(hours / 24);
    if (days < 7) {
      return days + ' days ago';
    }

    const weeks = Math.floor(days / 7);
    if (weeks < 4) {
      return weeks + ' weeks ago';
    }

    const months = Math.floor(weeks / 4);
    if (months < 12) {
      return months + ' months ago';
    }

    const years = Math.floor(months / 12);
    return years + ' years ago';
  }
}